/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tool_Share_DoneInputs */

const en_directory_tool_share_done = /** @type {(inputs: Directory_Tool_Share_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const zh_directory_tool_share_done = /** @type {(inputs: Directory_Tool_Share_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Directory_Tool_Share_DoneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_share_done = /** @type {((inputs?: Directory_Tool_Share_DoneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Share_DoneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_share_done(inputs)
	return zh_directory_tool_share_done(inputs)
});
export { directory_tool_share_done as "directory.tool.share_done" }